import client from './axiosClient';
import { API_ENDPOINTS } from "data/constants";

export class SignUpRequest {
	email: string;
	phone: string;
	password: string;
	confirmPassword: string;
	firstName: string;
	lastName: string;
	language: string;
	referralSource: string;
	notes: string;

	constructor() {
		this.email = '';
		this.phone = '';
		this.password = '';
		this.confirmPassword = '';
		this.firstName = '';
		this.lastName = '';
		this.language = '';
		this.referralSource = '';
		this.notes = '';
	}
}

export class ProfileCompletedResponse {
	status: boolean;
	uploadedIdDoc: boolean;
	contractConfirmed: boolean;
	filemakerSynced: boolean;

	constructor() {
		this.status = false;
		this.uploadedIdDoc = false;
		this.contractConfirmed = false;
		this.filemakerSynced = false;
	}
}

export const signUp = async (req: SignUpRequest) => {
	return client.post(API_ENDPOINTS.USER.REGISTER, req);
};

export const profileCompletedApi = async (): Promise<ProfileCompletedResponse> => {
	const response = await client.get(API_ENDPOINTS.USER.PROFILE_COMPLETED);
	return Object.assign(new ProfileCompletedResponse(), response.data);
};